module.exports = __webpack_public_path__ + "img/Procedures_Icon_Up.fc1818a4.svg";